import store from '../../../core/store';
import Permissions from '../constants/permissions';
import { NAMESPACE as POSTER_NAMESPACE } from '../store/modules/poster';

const routes = [
  {
    path: '/poster',
    name: '',
    component: () => import('../views/PosterHome'),
    children: [
      {
        path: 'dashboard',
        name: 'posterDashboard',
        component: () => import('../views/PosterDashboard'),
        meta: {
          permission: Permissions.DASHBOARD,
        },
      },
      {
        path: 'batch-creation',
        name: 'posterBatchCreation',
        component: () => import('../views/PosterBatchCreation'),
        meta: {
          permission: Permissions.QUICK,
        },
      },
      {
        path: 'creation',
        name: 'posterCreation',
        component: () => import('../views/PosterCreation'),
        meta: {
          permission: Permissions.QUICK,
        },
      },
      {
        path: 'list',
        name: 'posterDemands',
        component: () => import('../views/PosterDemands'),
        meta: {
          permission: Permissions.LOGS,
        },
      },
      {
        path: 'editor',
        name: 'posterEditor',
        component: () => import('../views/PosterEditor'),
        meta: {
          permission: Permissions.ADMIN,
        },
      },
      {
        path: 'renderer',
        name: 'posterRenderer',
        component: () => import('../views/PosterRenderer'),
        meta: {
          publicRoute: true,
          layout: 'renderer',
        },
      },
      {
        path: '',
        redirect: {
          name: 'posterDashboard',
        },
      },
    ],
  },
];

export default routes;
